<script setup lang="ts">
import ButtonV2 from '../ButtonV2/ButtonV2.vue';

const props = defineProps<{
  actionButtonLabel: string;
  cancelButtonLabel?: string;
  danger?: boolean;
  disabled?: boolean;
}>();

const emits = defineEmits<{
  onAction: [];
  onCancel: [];
}>();
</script>

<template>
  <div class="mt-8 flex justify-end gap-2">
    <ButtonV2
      v-if="props.cancelButtonLabel"
      :label="props.cancelButtonLabel"
      variant="neutral"
      @click="emits('onCancel')"
    />
    <ButtonV2
      :disabled="props.disabled"
      :variant="props.danger ? 'danger' : 'primary'"
      :label="props.actionButtonLabel"
      @click="emits('onAction')"
    />
  </div>
</template>
